import {HStack, IconButton, Text} from '@chakra-ui/react';
import React from 'react';
import {useNavigate} from "react-router-dom";
import {CirclePlus} from "lucide-react"
import Header from "./Header";
import {ChevronLeft} from 'lucide-react';
import {useLanguage} from "@/contexts/languageContext";

export const ListHeader = ({title, description, canGoBack}) => {
    const navigate = useNavigate();
    const { t } = useLanguage();

    return (
        <Header
            title={title}
            description={description}
            left={
                <HStack flex={1} align="center">
                    {
                        ![undefined, null, false].includes(canGoBack) &&
                        <IconButton
                            onClick={(_) => (canGoBack === true) ? navigate(-1) : navigate(canGoBack)}
                            isRound={true}
                            variant="iconOnly"
                            aria-label={t('actions.back')}
                            boxSize={10}
                            icon={<ChevronLeft />}
                        />
                    }
                </HStack>
            }
        />
    );
};

export default ListHeader;
